export const layerConf = {
  theoretical: {
    visibility: 'none',
    color: '#A9A7A7',
    group: 'sidewalk',
  },
  no_sidewalk: {
    visibility: 'none',
    color: '#FF0000',
    group: 'sidewalk',
  },
  walk: {
    visibility: 'none',
    color: '#36CF11',
    group: 'sidewalk',
  },
  described: {
    visibility: 'visible',
    color: '#FF7043',
    group: 'sidewalk',
  },
  drawn: {
    visibility: 'visible',
    color: '#42A5F5',
    group: 'sidewalk',
  },
  walk_cycle: {
    visibility: 'none',
    color: '#51ACC2',
    group: 'sidewalk',
  },
  crossing_path: {
    visibility: 'none',
    color: '#A455FF',
    group: 'crossing',
  },
  crossing_point: {
    visibility: 'none',
    color: '#F9B357',
    group: 'crossing',
  },
};
